import React from 'react';
import { AlertCircleIcon, CheckCircleIcon, LightbulbIcon } from 'lucide-react';
import { Configuration, Zone } from '../utils/types';
interface CompatibilityStatusProps {
  configuration: Configuration;
  zones: Zone[];
}
export function CompatibilityStatus({
  configuration,
  zones
}: CompatibilityStatusProps) {
  // Placeholder compatibility data
  const compatibilityData = [{
    zoneId: 1,
    status: 'OK',
    message: ''
  }, {
    zoneId: 2,
    status: 'Adapter',
    message: 'M30 termostat kræver adapter til manifold X'
  }, {
    zoneId: 3,
    status: 'Inkompatibel',
    message: 'CompB ventil ikke kompatibel med Roth manifold'
  }];
  // Placeholder AI suggestions
  const aiSuggestions = [{
    suggestion: 'Skift termostat til Roth Touchline® SL (WiFi): fuld kompatibilitet, +350 kr, ETA −3 dage'
  }, {
    suggestion: 'Brug Roth manifold 8 afgr. i stedet for CompA: bedre flow, samme pris, på lager'
  }];
  return <div className="bg-white rounded-2xl shadow-md p-5 border border-gray-100" data-id="element-47">
      <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-48">
        Kompatibilitet & Status
      </h2>
      {/* Zone status */}
      <div className="space-y-3 mb-6" data-id="element-49">
        {compatibilityData.map((item, index) => {
        const zone = zones.find(z => z.id === item.zoneId);
        return <div key={index} className="flex items-start" data-id="element-50">
              {item.status === 'OK' ? <CheckCircleIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-51" /> : item.status === 'Adapter' ? <AlertCircleIcon className="h-5 w-5 text-amber-500 mt-0.5 flex-shrink-0" data-id="element-52" /> : <AlertCircleIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" data-id="element-53" />}
              <div className="ml-2" data-id="element-54">
                <div className="flex items-center" data-id="element-55">
                  <span className="font-medium text-sm" data-id="element-56">
                    {zone?.name || `Zone ${item.zoneId}`}:
                  </span>
                  <span className={`ml-1 text-sm ${item.status === 'OK' ? 'text-green-600' : item.status === 'Adapter' ? 'text-amber-600' : 'text-red-600'}`} data-id="element-57">
                    {item.status}
                  </span>
                </div>
                {item.message && <p className="text-xs text-gray-600 mt-0.5" data-id="element-58">{item.message}</p>}
              </div>
            </div>;
      })}
      </div>
      {/* AI suggestions */}
      <div className="bg-blue-50 rounded-xl p-3 mb-6" data-id="element-59">
        <div className="flex items-center mb-2" data-id="element-60">
          <LightbulbIcon className="h-4 w-4 text-blue-600 mr-1.5" data-id="element-61" />
          <h3 className="text-sm font-medium text-blue-700" data-id="element-62">AI-forslag</h3>
        </div>
        <ul className="space-y-2" data-id="element-63">
          {aiSuggestions.map((item, index) => <li key={index} className="text-xs text-blue-800 flex items-start" data-id="element-64">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-blue-400 mt-1.5 mr-1.5 flex-shrink-0" data-id="element-65"></span>
              {item.suggestion}
            </li>)}
        </ul>
      </div>
      {/* Inventory/ETA overview */}
      <div className="mb-6" data-id="element-66">
        <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-67">
          Lager/ETA Status
        </h3>
        <div className="flex flex-wrap gap-2" data-id="element-68">
          <div className="bg-green-50 px-2.5 py-1 rounded-md text-xs text-green-700" data-id="element-69">
            Roth komponenter: På lager
          </div>
          <div className="bg-amber-50 px-2.5 py-1 rounded-md text-xs text-amber-700" data-id="element-70">
            CompA termostater: 2-3 uger
          </div>
          <div className="bg-green-50 px-2.5 py-1 rounded-md text-xs text-green-700" data-id="element-71">
            CompB rør: På lager
          </div>
        </div>
      </div>
      {/* Environment chip */}
      <div className="flex items-center" data-id="element-72">
        <div className="bg-emerald-50 px-3 py-1.5 rounded-lg text-xs text-emerald-700 flex items-center" data-id="element-73">
          <svg className="h-3.5 w-3.5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-74">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-75" />
          </svg>
          <span data-id="element-76">Grøn profil</span>
        </div>
      </div>
    </div>;
}